<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h11">A<span class="th13">CKNOWLEDGMENTS</span></h1>
<p class="p10"> </p>
<p class="p10"> </p>
<p class="p11"><span class="t13">There are always people to thank, people who have helped me, supported me, and more. These people are the unsung heroes in my life, and this is my shout-out to them and my eternal thank-you to all of them.</span></p>
<p class="p11">In gratitude to Cate Ashwood, one of the best besties a person could ask for; Meredith Shayne, Marina Pycroft, Sue Cavanagh-Lang, Claire Clarke, Tracy Bailey, Jazz Pycroft, Alex Dewar, Erin, Michelle Wauchope; Shane Bevin, Chris Spud, Hermann Lauss, Harry Butler, Terry Rowe, FAL, Tien, and Zathyn Priest. For my family: Mum, Dad, Dr. Ian, Christy and Shandi, my brother John.</p>
<p class="p11">And my eternal gratitude to Dreamspinner Press, including Elizabeth North, Lynn West, Erika Orrick, Anne Cain, and everyone else at DSP.</p>
<p class="p11">Thank you.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 007.vue?000e29c0